import { deleteRequest, get, publicPost, put } from "../helpers/apihelpers";

export const CreateMetaService=async(data)=>{
    try {
        const result = await publicPost(`api/promotional/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateMetaService=async(data,id)=>{
    try {
        const result = await put(`api/promotional/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetMetaService=async(page,from_date,to_date,text)=>{
    try {
        const result = await get(`api/promotional/get?page=${page}&from_date=${from_date}&to_date=${to_date}&text=${text}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteMetaService=async(id)=>{
    try {
        const result = await deleteRequest(`api/promotional/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteAllMetaService=async()=>{
    try {
        const result = await deleteRequest(`api/promotional/delete_all`);
        return result;
    } catch (err) {
        return err.response;
    }
}